import React from 'react';
import { useParams } from 'react-router-dom';
import { AnalyticsDashboard } from '../components/analytics';
import './AnalyticsPage.css';

const AnalyticsPage: React.FC = () => {
  const { documentId } = useParams<{ documentId: string }>();
  
  if (!documentId) {
    return (
      <div className="analytics-page error">
        <div className="error-container">
          <h1>Analytics Not Available</h1>
          <p>Document ID is required to view analytics.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="analytics-page">
      <AnalyticsDashboard documentId={documentId} />
    </div>
  );
};

export default AnalyticsPage;